import produce from 'immer';
import _set from 'lodash/set';
var addOptionsToAdditional = produce(function (filterType, options) {
  _set(filterType, 'additional.options', options);
});
export default addOptionsToAdditional;